module.exports = __webpack_public_path__ + "static/img/deal_3.8ee68f4d.png";